import { useEffect } from 'react'
import { Link, useSearchParams } from 'react-router-dom'
import { supabase } from '../../../lib/supabase'
import Navbar from '../../../components/Navbar'
import Footer from '../../../components/Footer'

export default function ShopCancel() {
  const [searchParams] = useSearchParams()
  const orderId = searchParams.get('order_id')

  useEffect(() => {
    if (!orderId) return
    supabase
      .from('orders')
      .update({ status: 'cancelled', updated_at: new Date().toISOString() })
      .eq('id', orderId)
      .then(() => {})
  }, [orderId])

  return (
    <div className="min-h-screen bg-white dark:bg-black text-gray-900 dark:text-white flex flex-col">
      <Navbar />
      <div className="flex-1 flex items-center justify-center px-4 py-20">
        <div className="max-w-md w-full text-center">
          <div className="w-16 h-16 bg-gray-100 dark:bg-white/5 border border-gray-200 dark:border-white/10 flex items-center justify-center mx-auto mb-6">
            <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" className="text-gray-400">
              <line x1="18" y1="6" x2="6" y2="18"/>
              <line x1="6" y1="6" x2="18" y2="18"/>
            </svg>
          </div>
          <h1 className="text-3xl font-black uppercase tracking-tight mb-3 text-gray-900 dark:text-white">
            Payment Cancelled
          </h1>
          <p className="text-gray-500 text-sm mb-8 leading-relaxed">
            Your payment was cancelled. Your cart items are still available — you can try again whenever you are ready.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <Link
              to="/shop"
              className="bg-green-600 hover:bg-green-700 text-white px-6 py-3 text-xs font-bold uppercase tracking-widest transition-colors"
            >
              Return to Shop
            </Link>
            <Link
              to="/dashboard"
              className="border border-gray-200 dark:border-white/10 hover:border-green-600 text-gray-500 dark:text-gray-400 hover:text-green-600 dark:hover:text-white px-6 py-3 text-xs font-bold uppercase tracking-widest transition-colors"
            >
              Go to Dashboard
            </Link>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}